
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/2020-11-02-x100v",
      function () {
        return require("private-next-pages/posts/2020-11-02-x100v.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/2020-11-02-x100v"])
      });
    }
  